// const server = "http://localhost";
// const domain = "localhost";
// const port = 9666;
const serverImg = 'https://disluda.nbg1.your-objectstorage.com/public';
const server = "https://apidisluda.mansolutions.app";
const port = 443;
const domain = "disluda.mansolutions.app";
export { server, port, domain, serverImg };
